<template>
  <div class="sale-trend" ref="chartContainer"></div>
</template>

<script>
import * as echarts from 'echarts/core'
import { LineChart } from 'echarts/charts'
import { TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import { CanvasRenderer } from 'echarts/renderers'
import { saleTrend } from '../mock/data'

echarts.use([LineChart, TooltipComponent, LegendComponent, GridComponent, CanvasRenderer])

export default {
  name: 'SaleTrend',
  data() {
    return { chart: null }
  },
  mounted() {
    this.initChart()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    if (this.chart) this.chart.dispose()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.chartContainer)
      var option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(6,30,60,0.9)',
          borderColor: 'rgba(0,212,255,0.3)',
          textStyle: { color: '#FFFFFF', fontSize: 12 },
          formatter: function(params) {
            var s = params[0].axisValue + '<br/>'
            params.forEach(function(p) {
              s += p.marker + ' ' + p.seriesName + ': ' + (p.value / 10000).toFixed(1) + '万元<br/>'
            })
            return s
          }
        },
        legend: {
          data: ['淘宝/天猫', '京东', '拼多多', '抖音'],
          textStyle: { color: '#B0D4F1', fontSize: 11 },
          top: 0,
          right: 10,
          itemWidth: 16,
          itemHeight: 3
        },
        grid: {
          left: 50,
          right: 20,
          top: 30,
          bottom: 25
        },
        xAxis: {
          type: 'category',
          data: saleTrend.dates,
          axisLine: { lineStyle: { color: 'rgba(0,212,255,0.3)' } },
          axisLabel: { color: '#B0D4F1', fontSize: 10, interval: 4 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLine: { show: false },
          axisLabel: {
            color: '#B0D4F1',
            fontSize: 10,
            formatter: function(v) { return (v / 10000).toFixed(0) + '万' }
          },
          splitLine: { lineStyle: { color: 'rgba(0,212,255,0.1)' } }
        },
        series: [
          {
            name: '淘宝/天猫',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#00D4FF' },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,212,255,0.3)' },
              { offset: 1, color: 'rgba(0,212,255,0.02)' }
            ]) },
            data: saleTrend.taobao
          },
          {
            name: '京东',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#00FF88' },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(0,255,136,0.2)' },
              { offset: 1, color: 'rgba(0,255,136,0.02)' }
            ]) },
            data: saleTrend.jd
          },
          {
            name: '拼多多',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#FF6B35' },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(255,107,53,0.15)' },
              { offset: 1, color: 'rgba(255,107,53,0.02)' }
            ]) },
            data: saleTrend.pdd
          },
          {
            name: '抖音',
            type: 'line',
            smooth: true,
            symbol: 'none',
            lineStyle: { width: 2, color: '#A855F7' },
            areaStyle: { color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: 'rgba(168,85,247,0.15)' },
              { offset: 1, color: 'rgba(168,85,247,0.02)' }
            ]) },
            data: saleTrend.douyin
          }
        ]
      }
      this.chart.setOption(option)
    },
    handleResize() {
      if (this.chart) this.chart.resize()
    }
  }
}
</script>

<style scoped>
.sale-trend {
  width: 100%;
  min-height: 200px;
}
</style>
